import React from 'react';

const OverviewTab = ({ player, phaseLocks }) => {
  return (
    <div className="guess-section overview-section">
      <h3 className="guess-section-title">Point Oversigt</h3>
      <div className="guess-content">
        <div className="overview-grid">
          {!phaseLocks.phase0 && (
            <div className="overview-item">
              <span className="overview-label">🏆 Fase 0 - Gæt Vinderen:</span>
              <span className="overview-value">{player.phase0Points || 0} point</span>
            </div>
          )}
          {!phaseLocks.phase1 && (
            <div className="overview-item">
              <span className="overview-label">📊 Fase 1 - Liga Stilling:</span>
              <span className="overview-value">{player.phase1Points || 0} point</span>
            </div>
          )}
          {!phaseLocks.phase2 && (
            <div className="overview-item">
              <span className="overview-label">⚔️ Fase 2 - Knockout:</span>
              <span className="overview-value">{player.phase2Points || 0} point</span>
            </div>
          )}
          {!phaseLocks.phase3 && (
            <div className="overview-item">
              <span className="overview-label">🏅 Fase 3 - Finalen:</span>
              <span className="overview-value">{player.phase3Points || 0} point</span>
            </div>
          )}
        </div>
        <div className="total-points-section">
          <h3>Total Point</h3>
          <p className="total-points-value">{player.points || 0} point</p>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;

